module.exports = __webpack_public_path__ + "media/hp-case-spin.71f91066.wav";